import { Button, Container, Stack, Text, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container size="md" py="xl">
      <Stack align="center" gap="lg">
        <Title order={1} size="3rem" ta="center">
          404
        </Title>
        <Title order={2} ta="center">
          Page Not Found
        </Title>
        <Text c="dimmed" ta="center" size="lg">
          The page you are looking for doesn&apos;t exist or has been moved.
        </Text>
        <Button onClick={() => navigate('/')} size="lg">
          Go to Home
        </Button>
      </Stack>
    </Container>
  );
};
